var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticStyle:{"width":"100%","height":"100%"},attrs:{"element-loading-text":"拼命加载中"}})
}
var staticRenderFns = []

export { render, staticRenderFns }